"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatContainer = exports.ChatButtonLabel = exports.QuestionIcon = exports.ChatButtonItem = exports.ChatButtonWrapper = exports.ChatButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../assets/js/constants");

var _icon = _interopRequireDefault(require("../icon"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ChatButton = _styledComponents["default"].div.withConfig({
  displayName: "styled__ChatButton",
  componentId: "rlvyqf-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: fixed;\n    width: ", ";\n    height: 60px;\n    bottom: 24px;\n    z-index: 200;\n    right: 35px;\n    cursor: pointer;\n    transform: translate3d(0, 0, 0);\n    backface-visibility: hidden;\n    transition: bottom 0.2s ease-in, width 0.8s cubic-bezier(0.23, 1, 0.32, 1);\n    @media (max-width: 1187px) {\n        width: 60px;\n        bottom: 7px;\n        right: 15px;\n    }\n"])), function (props) {
  return props.expanded ? '270px' : '60px';
});

exports.ChatButton = ChatButton;

var ChatButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styled__ChatButtonWrapper",
  componentId: "rlvyqf-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n"])));

exports.ChatButtonWrapper = ChatButtonWrapper;

var ChatButtonItem = _styledComponents["default"].div.withConfig({
  displayName: "styled__ChatButtonItem",
  componentId: "rlvyqf-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: block;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    &:before {\n        content: \" \";\n        display: block;\n        width: 60px;\n        height: 60px;\n        margin: 0 auto;\n        border-radius: 50%;\n        background-color: ", ";\n    }\n    @media (max-width: 1187px) {\n        margin-bottom: 0;\n        right: 0;\n        &:before {\n            width: 50px;\n            height: 50px;\n        }\n    }\n "])), _constants.COLORS.green);

exports.ChatButtonItem = ChatButtonItem;
var QuestionIcon = (0, _styledComponents["default"])(_icon["default"]).withConfig({
  displayName: "styled__QuestionIcon",
  componentId: "rlvyqf-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    color: ", ";\n    position: absolute;\n    width: 100%;\n    text-align: center;\n    font-size: 28px;\n    top: 18px;\n    @media (max-width: 1187px) {\n        top: 12px;\n    }\n"])), _constants.COLORS.white);
exports.QuestionIcon = QuestionIcon;

var ChatButtonLabel = _styledComponents["default"].div.withConfig({
  displayName: "styled__ChatButtonLabel",
  componentId: "rlvyqf-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: block;\n    background: #515b60;\n    color: ", ";\n    padding-right: 23px;\n    border-radius: 50px;\n    width: 100%;\n    height: 60px;\n    white-space: nowrap;\n    text-align: right;\n    font-size: 17px;\n    line-height: 3.6;\n    transition: color 0.2s cubic-bezier(0.23, 1, 0.32, 1);\n    @media (max-width: 1187px) {\n        display: none;\n    }\n"])), function (props) {
  return props.expanded ? _constants.COLORS.white : '#515b60';
});

exports.ChatButtonLabel = ChatButtonLabel;

var ChatContainer = _styledComponents["default"].iframe.withConfig({
  displayName: "styled__ChatContainer",
  componentId: "rlvyqf-5"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    z-index: 500;\n    position: fixed;\n    top: ", ";\n    right: 0;\n    height: ", ";\n    box-shadow: 0 1px 16px 0 rgba(0,0,0,0.24);\n    background: white;\n    @media (max-width: 767px) {\n        width: 100vw;\n        height: 100%;\n    }\n"])), function (props) {
  return props.top ? props.top : '0';
}, function (props) {
  return props.height ? props.height : '100vh';
});

exports.ChatContainer = ChatContainer;